import {RichText} from '@gongxigames/framework/core/fragments/display';

RichText.setStyle('watermark_desktop', {
    fontSize: 41,
    fill: 0xd1d1d1,
    align: 'right',
    verticalAlign: 'bottom',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold'
});

RichText.setStyle('watermark_mobile', {
    fontSize: 51,
    fill: 0xd1d1d1,
    verticalAlign: 'top',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold'
});

RichText.setStyle('watermark_mobile_portrait', {
    fontSize: 48,
    fill: 0xd1d1d1,
    verticalAlign: 'top',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold'
});
